import { render, staticRenderFns } from "./PageScreeningAsset.vue?vue&type=template&id=d8f6296c&scoped=true"
import script from "./PageScreeningAsset.vue?vue&type=script&lang=js"
export * from "./PageScreeningAsset.vue?vue&type=script&lang=js"
import style0 from "./PageScreeningAsset.vue?vue&type=style&index=0&id=d8f6296c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f6296c",
  null
  
)

export default component.exports